import { render } from "./Ping.vue?vue&type=template&id=4be91e96"
import script from "./Ping.vue?vue&type=script&lang=js"
export * from "./Ping.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__